import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CacheService } from '../services/cache.service';
import { WorkflowService } from '../services/workflow.service';

@Injectable()
export class RequestExternalCommunicationProcessesService extends WorkflowService {
  constructor(http: HttpClient, cache: CacheService) {
    super(http, 'OrderRequestExternalCommunicationProcesses', cache);
  }

  getExternalCommunicationsEvents<T>(page: number, pageSize: number, id: number, body: any): Observable<T> {
    return this.post<any, T>(`${id}/Events`, body, {
      params: this.setParams({
        page,
        pageSize,
      }),
    });
  }

  public markKoAsChecked(id: number, description: string) {
    return this.put<{ id: number; description: string }, void>(`${id}/KoCheck`, { id, description });
  }

  getExternalCommunicationsBody(id: number, eventId: number): Observable<string> {
    return this.get<string>(`${id}/Events/${eventId}`, { observe: 'response', responseType: 'text' });
  }
}
